// FLOW Platform — FHT frontend entry point.
//
// Runs once on script load. Behaviour:
//
//   1. If the mount node `#flow-fht-root` is not on the page, do nothing.
//      (The bundle is enqueued only when the shortcode renders, but the
//      defensive check costs nothing and lets us also load the bundle
//      globally for future test-mode launches.)
//   2. Read the inline config that WordPress's wp_localize_script wrote
//      into `window.flowFhtConfig`.
//   3. Hand off to `bootShell` from shell.js.
//
// We intentionally do not import any framework. The shell is plain DOM.

import './styles.css';
import { bootShell } from './shell.js';

function start() {
  const mount = document.getElementById('flow-fht-root');
  if (!mount) {
    return;
  }

  const config = window.flowFhtConfig;
  if (!config || typeof config.restBase !== 'string' || config.restBase === '') {
    // No config — render a static error so the page isn't blank.
    mount.innerHTML =
      '<div class="flow-fht-fatal" role="alert">' +
      'The FHT game is not configured. Please contact the site owner.' +
      '</div>';
    return;
  }

  bootShell(mount, config);
}

// Run as soon as the DOM is parseable.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
